import React, { useEffect } from 'react'
import { useFormik } from 'formik'
import { getUserId } from '../../helpers/auth'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { Button, Input, Modal } from 'antd'
import Loader from '../../pages/pages/loader'
import {
  useCreateIpAddressMutation,
  useUpdateIpAddressMutation
} from '../../redux/apis/domainsManagement/ipAddress/dMIpAddressApiSlice'
import IspDropdown from '../IspDropdown'

const EditCreateIpAddress = ({ state, open, setOpen, record }) => {
  const [
    updateService,
    { isLoading: isUpdating, isSuccess: SuccessUpdate, error: errorUpdate }
  ] = useUpdateIpAddressMutation()
  const [
    addService,
    { isLoading: isAdding, isSuccess: SuccessAdd, error: errorAdd }
  ] = useCreateIpAddressMutation()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      ip_address: record?.ip_address || '',
      isp: record?.isp?.id || '',
      last_updated_by: getUserId()
    },

    validationSchema: Yup.object({
      ip_address: Yup.string().required('Please Enter IP Address'),
      isp: Yup.string().required('Please Enter ISP')
    }),

    onSubmit: async values => {
      const formData = new FormData()
      for (let key in values) {
        formData.append(key, values[key])
      }

      try {
        if (state === 'edit') {
          await updateService({
            body: formData,
            id: record?.id
          }).unwrap()
        } else if (state === 'create') {
          await addService(formData).unwrap()
        }
      } catch (err) {
        console.error(err)
      }
    }
  })

  useEffect(() => {
    if (errorAdd?.data) {
      const errorMessages = Object.values(errorAdd.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    } else if (errorUpdate?.data) {
      const errorMessages = Object.values(errorUpdate.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [errorAdd, errorUpdate])

  useEffect(() => {
    console.log(SuccessAdd, SuccessUpdate)
    if (SuccessAdd && state === 'create') {
      toast.success('IP Address created successfully!')
      setOpen(false)
    } else if (SuccessUpdate && state === 'edit') {
      toast.success('IP Address updated successfully!')
      setOpen(false)
    }
  }, [state, SuccessAdd, SuccessUpdate])

  return (
    <Modal
      className='customModal'
      open={open}
      title={state === 'edit' ? `Edit IP` : 'Create IP'}
      onCancel={() => setOpen(false)}
      footer={[
        <Button key='back' onClick={() => setOpen(false)}>
          Cancel
        </Button>,
        <Button
          key='submit'
          type='primary'
          onClick={() => {
            if (Object.keys(validation.errors).length !== 0) {
              Object.keys(validation.errors).map(key => {
                toast.error(validation.errors[key])
              })
              return
            }
            validation.handleSubmit()
          }}
        >
          Submit
        </Button>
      ]}
    >
      <Loader isLoading={isAdding || isUpdating} />

      <div className=' mb-3'>
        <label className="form-label">IP Address</label>
        <Input
          type='text'
          name='ip_address'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.ip_address}
        />
        {validation.touched.ip_address && validation.errors.ip_address ? (
          <p className='text-danger'>{validation.errors.ip_address}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <IspDropdown
          onChange={e => validation.setFieldValue('isp', e)}
          onBlur={validation.handleBlur}
          value={validation.values.isp}
          validation={validation}
        />
        {validation.touched.isp && validation.errors.isp ? (
          <p className='text-danger'>{validation.errors.isp}</p>
        ) : null}
      </div>
    </Modal>
  )
}

export default EditCreateIpAddress
